export default "__VITE_ASSET__fn5O1wjQ__"